import { Injectable, computed, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private readonly pending = signal(0);
  readonly isLoading = computed(() => this.pending() > 0);

  increment(): void { this.pending.update(n => n + 1); }
  decrement(): void { this.pending.update(n => Math.max(0, n - 1)); }
}
